if (!customElements.get("collection-sort")) {
  class CollectionSort extends HTMLElement {
    constructor() {
      super();
    }

    /**
     * @param {Event & { currentTarget: HTMLSelectElement }} e
     */
    handleChange = (e) => {
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", e.currentTarget.value);
      window.location.href = url.toString();
    };

    connectedCallback() {
      requestAnimationFrame(() => {
        this.removeAttribute("inert");
        this.removeAttribute("aria-hidden");
        this.classList.remove("blink");

        const select = this.querySelector("select");
        select?.removeAttribute("disabled");
        select?.addEventListener("change", this.handleChange);
      });
    }
  }
  customElements.define("collection-sort", CollectionSort);
}
